import { render } from "./PieChartBox.vue?vue&type=template&id=083128c6"
import script from "./PieChartBox.vue?vue&type=script&lang=js"
export * from "./PieChartBox.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__